/**
 * @file Pricing Tooltip
 */

import { gsap } from 'gsap';
import { createPopper } from '@popperjs/core';

/**
 * Pricing Tooltip component
 */
const vPricingTooltip = () => {
	const tooltips = document.querySelectorAll( '.v-pricing-tooltip' );

	if ( ! tooltips.length ) {
		return;
	}

	[ ...tooltips ].forEach( ( tooltip ) => {
		const { id }    = tooltip;
		const trigger   = document.querySelector( `[data-tooltip-trigger="${ id }"]` );
		const wrap      = tooltip.querySelector( '.v-pricing-tooltip__wrap' );
		let isAnimating = false;
		const popper    = createPopper( trigger, tooltip, {
			placement: tooltip.getAttribute( 'data-popper-placement' ) || 'top',
			modifiers: [ {
				name: 'flip',
			} ],
		} );

		/**
		 * Toggle tooltip
		 *
		 * @param {Event} e The event
		 */
		const toggleTooltip = ( e ) => {
			e.preventDefault();

			if ( isAnimating ) {
				return;
			}

			const poppingIn = tooltip.hasAttribute( 'data-hidden' );

			const tl = gsap.timeline( {
				defaults: { ease: 'sine.out' },
				onStart:  () => {
					if ( poppingIn ) {
						tooltip.removeAttribute( 'data-hidden' );
					}

					isAnimating = true;
				},
				onComplete: () => {
					if ( ! poppingIn ) {
						tooltip.setAttribute( 'data-hidden', '' );
					}

					wrap.removeAttribute( 'style' );
					isAnimating = false;
				},
			} );

			if ( poppingIn ) {
				tl.to( wrap, {
					opacity: 1,
				} );
			} else {
				tl.to( wrap, {
					opacity: 0,
				} );
			}
		};

		/**
		 * Close tooltip (with no animation)
		 */
		const closeTooltip = () => {
			isAnimating = true;
			tooltip.setAttribute( 'data-hidden', '' );
			setTimeout( () => {
				isAnimating = false;
			}, 300 );
		};

		trigger.addEventListener( 'click', toggleTooltip );
		trigger.addEventListener( 'touchend', toggleTooltip );

		document.addEventListener( 'click', ( e ) => {
			if ( ! tooltip.contains( e.target ) ) {
				closeTooltip();
			}
		} );

		document.addEventListener( 'vPricingCardChange', ( { detail } ) => {
			const { action, target } = detail;

			if ( ! target.contains( trigger ) ) {
				return;
			}

			if ( action === 'open' ) {
				popper.update();
			} else if ( action === 'close' && ! isAnimating ) {
				tooltip.setAttribute( 'data-hidden', '' );
			}
		} );

		document.addEventListener( 'keydown', ( e ) => {
			// if key is escape and tooltip is open, close it
			if ( e.key === 'Escape' && ! tooltip.hasAttribute( 'data-hidden' ) ) {
				closeTooltip();
			}
		} );
	} );
};

export default vPricingTooltip;
